import * as React from 'react'

import { cva, cx, type VariantProps } from '@/libs/cva'

// Classnames

type ContainerVariantProps = VariantProps<typeof containerVariants>
const containerVariants = cva({
	base: cx(
		'w-full divide-ui-border-strong overflow-hidden rounded-lg bg-ui-bg-component px-6 py-4 shadow-elevation-card-rest'
	),
	variants: {
		variant: {
			innercard: cx(
				'w-auto border border-ui-border-menu-top shadow-elevation-code-block'
			),
			transparent: cx('bg-transparent', 'border-none', 'shadow-none'),
		},
	},
	defaultVariants: {},
})

interface ContainerProps
	extends React.ComponentPropsWithoutRef<'div'>,
		ContainerVariantProps {}

/**
 * This component is based on the `div` element and supports all of its props
 */
const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
	({ className, variant, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={cx(containerVariants({ variant }), className)}
				{...props}
			/>
		)
	}
)
Container.displayName = 'Container'

export { Container }
